<template>
    <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
        <h4><strong style="color:#1A0054">Nueva cuenta empresarial</strong></h4>

        <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="agregar_empresa">
            <div class="row justify-content-center align-items-center">
                <div class="col-sm-12 col-md-6 col-lg-6 align-self-center">
                    <h4><strong style="color:#494949">Agregar cuenta empresarial</strong></h4>
                    <small>Completa el formulario para agregar un nuevo usuario administrador, o SU especificar que es un
                        rol especial y sensible </small>
                    <br>
                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" v-model="newClient.name" class="form-control rounded-8 sin-borde"
                                placeholder="Nombre de la empresa" aria-label="Nombre de la empresa" id="company-name"
                                required />
                            <span class="text-danger" v-if="error.name">El nombre de la empresa es un campo
                                obligatorio</span>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" v-model="newClient.website" class="form-control rounded-8 sin-borde"
                                placeholder="URL Sitio web" aria-label="URL Sitio web" id="company-url" />
                            <span class="text-danger" v-if="error.website">La url de la empresa es un campo
                                obligatorio</span>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <span><b>Logo</b> 300x300 px en JPG, JPEG, PNG</span>
                            <input type="file" v-on:change="attachImage" ref="profilePhoto"
                                class="form-control rounded-8 sin-borde" placeholder="Logo" aria-label="Logo"
                                id="company-logo" accept=".jpg, .jpeg, .png"/>
                            <span class="text-danger" v-if="error.website">La url de la empresa es un campo
                                obligatorio</span>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <label for="company-licence"><strong>Nivel del plan empresarial</strong></label>
                            <select v-model="newClient.licencia" @change="onLicenceChange($event)" id="company-licence"
                                class="form-control rounded-8 sin-borde">
                                <option value="" disabled selected>Seleccione una opción</option>
                                <option v-for="licence of licences" :key="licence.id" :value="licence.id"
                                    :data-users="licence.accepted_users" :data-routes="licence.accepted_routes"
                                    :data-courses="licence.accepted_courses">
                                    {{ licence.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <label for="client-etapa"><strong>Etapa de la empresa</strong></label>
                            <select v-model="newClient.etapa_empresa" class="form-control rounded-8 sin-borde"
                                id="client-etapa">
                                <option value="">Seleccione una opción</option>
                                <option value="free_trial">Free Trial</option>
                                <option value="pago">Pago</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <label for="client-tipo"><strong>Tipo de la empresa</strong></label>
                            <select v-model="newClient.tipo_empresa" class="form-control rounded-8 sin-borde"
                                id="client-tipo">
                                <option value="">Seleccione una opción</option>
                                <option value="empresa_interna">Empresa interna</option>
                                <option value="empresa_real">Empresa real</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <label for="company-domain"><strong>Dominio</strong></label>
                            <select v-model="newClient.domain_id" id="company-domain"
                                class="form-control rounded-8 sin-borde">
                                <option value="" disabled selected>Seleccione una opción</option>
                                <option v-for="domain of domains" :key="domain.id" :value="domain.id">
                                    {{ domain.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="license-users" class="form-control rounded-8 sin-borde"
                                placeholder="Número de usuarios y/o colaboradores"
                                aria-label="Número de usuarios y/o colaboradores" readonly disabled />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="license-courses" class="form-control rounded-8 sin-borde"
                                placeholder="Número de cursos disponibles" aria-label="Número de cursos disponibles"
                                readonly disabled />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <label for=""><strong>Datos del administrador</strong></label>
                            <input type="text" id="user-name" v-model="newUser.firstname"
                                class="form-control rounded-8 sin-borde" placeholder="Nombre" aria-label="Nombre"
                                required />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="user-name" v-model="newUser.lastname"
                                class="form-control rounded-8 sin-borde" placeholder="Apellido" aria-label="Apellido"
                                required />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="email" id="user-email" v-model="newUser.email"
                                class="form-control rounded-8 sin-borde" placeholder="Correo electrónico"
                                aria-label="Correo electrónico" @keyup="validateEmailFomat($event)"
                                @change="validateEmailExists($event)" required />
                            <small style="color:red" class="d-none" id="errorEmailFormatMessage">El correo tiene un formato
                                no valido.</small>
                            <small style="color:red" class="d-none" id="errorEmailExists">El email registrado ya
                                existe</small>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="user-cellphone" v-model="newUser.cellphone"
                                class="form-control rounded-8 sin-borde" placeholder="Número de celular"
                                aria-label="Número de celular" @keyup="validatePhone($event)" required />
                            <small style="color:red" class="d-none" id="errorPhoneText">El número de celular debe ser mayor
                                a 9 digitos.</small>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="user-position" v-model="newUser.position"
                                class="form-control rounded-8 sin-borde" placeholder="Cargo" aria-label="Cargo" required />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="user-area" v-model="newUser.area"
                                class="form-control rounded-8 sin-borde" placeholder="Área" aria-label="Área" required />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" id="user-area-level" v-model="newUser.level"
                                class="form-control rounded-8 sin-borde" placeholder="Nivel de área"
                                aria-label="Nivel de área" required />
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="form-group">
                            <span>Firma del administrador. 300x300 px en JPG, JPEG, PNG</span>
                            <input type="file" v-on:change="attachSign" ref="signPhoto"
                                class="form-control rounded-8 sin-borde" placeholder="Logo" aria-label="Logo"
                                id="admin-firma" accept="image/*" required />                            
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="d-flex gap-4 justify-content-end">
                            <button
                                id="add-company"
                                type="button"
                                class="btn btn-primary text-light rounded-8"
                                @click="addClient()"
                            >
                                Guardar empresa
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['get', 'licences', 'urlvalidateemail', 'domains'],
    data() {
        return {
            newClient: { name: "", licencia: '', logo_cliente: '', etapa_empresa: '', tipo_empresa: '', website: '', domain_id : '1' },
            newUser: {
                logo_cliente: '',
                firstname: "",
                lastname: "",
                role: 'admin',
                cellphone: '',
                position: '',
                area: '',
                level: '',
                email: '',
                file: ''
            },
            url: this.get,
            error: [],
            isValidEmail: false,
            isValidPhone: false
        }
    },
    methods: {
        attachImage() {
            this.newUser.logo_cliente = this.$refs.profilePhoto.files[0];
            this.newClient.logo_cliente = this.$refs.profilePhoto.files[0];
        },
        attachSign() {
            this.newUser.file = this.$refs.signPhoto.files[0];
        },
        onLicenceChange(event) {
            let users = event.target.selectedOptions[0].dataset.users;
            let courses = event.target.selectedOptions[0].dataset.courses;
            document.getElementById("license-users").value = users;
            document.getElementById("license-courses").value = courses;
        },
        addClient() {
            if (!this.validate()) return

            const btn = document.getElementById("add-company")
            btn.textContent = "Procesando ..."

            const formData = new FormData()
            formData.append('data', JSON.stringify(this.newClient))
            if (this.newClient.logo_cliente) {
                formData.append('file', this.newClient.logo_cliente)
            }

            axios.post(this.url, formData, { headers: { 'content-type': 'multipart/form-data' } })
                .then((res) => {
                    if (res.status === 200) {
                        this.addUserClient(res.data.client)
                    }
                })
                .catch((err) => {
                    console.error(err)
                    btn.textContent = 'Guardar empresa'
                    this.$swal('Error al crear la empresa.')
                })
        },
        addUserClient(client) {
            const btn = document.getElementById("add-company")
            this.newUser.client = client
            
            const formData = new FormData()
            Object.entries(this.newUser).forEach(([key, value]) => {
                formData.append(key, value)
            })

            axios.post(`/client/${client}/users`, formData, { headers: { 'content-type': 'multipart/form-data' } })
                .then(() => {
                    this.resetForm()
                    btn.textContent = 'Guardar empresa'
                    this.$swal('Empresa y usuario administrador creados exitosamente.')
                    this.$emit('refreshtable')
                })
                .catch((err) => {
                    console.error(err)
                    this.error = err.response?.data?.errors || {}
                    btn.textContent = 'Guardar empresa'
                    this.$swal('Error al crear el usuario de la empresa')
                })
        },
        resetForm() {
            this.newClient = { name: "", licencia: '', logo_cliente: '', etapa_empresa: '', tipo_empresa: '', website: '', domain_id: '1' }
            this.newUser = { logo_cliente: '', firstname: "", lastname: "", role: 'admin', cellphone: '', position: '', area: '', level: '', email: '', file: '' }
            document.getElementById("license-users").value = ''
            document.getElementById("license-courses").value = ''
        },
        validateEmailFomat(val) {
            const value = val.target.value;
            let validarCorreoTexto = document.getElementById('errorEmailFormatMessage');
            if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)) {
                validarCorreoTexto.classList.remove('d-block');
                validarCorreoTexto.classList.add('d-none');
                this.isValidEmail = true;
            } else {
                validarCorreoTexto.classList.remove('d-none');
                validarCorreoTexto.classList.add('d-block');
                this.isValidEmail = false;
            }
        },
        validateEmailExists(event) {
            const value = event.target.value;
            const errorMessageTag = document.getElementById('errorEmailExists');
            axios.post(this.urlvalidateemail, { "email": value })
                .then((res) => {
                    if (!res.data.available) {
                        errorMessageTag.classList.remove('d-none');
                        errorMessageTag.classList.add('d-block');
                        this.isValidEmail = false;
                    } else {
                        errorMessageTag.classList.remove('d-block');
                        errorMessageTag.classList.add('d-none');
                        this.isValidEmail = true;
                    }
                })
        },
        validatePhone(val) {
            const value = val.target.value;
            let validarcelularTexto = document.getElementById('errorPhoneText');
            if (value.length >= 9) {
                validarcelularTexto.classList.remove('d-block');
                validarcelularTexto.classList.add('d-none');
                this.isValidPhone = true;
            } else {
                validarcelularTexto.classList.remove('d-none');
                validarcelularTexto.classList.add('d-block');
                this.isValidPhone = false;
            }
        },
        validate() {
            let isValid = true
            const formContainer = document.getElementById("agregar_empresa")
            const client_plan = document.getElementById("company-licence")
            const inputs = formContainer.querySelectorAll("input[required]")

            inputs.forEach(input => {
                if (input.value.trim().length < 1) {
                    input.classList.add('invalid')
                    isValid = false
                } else {
                    input.classList.remove('invalid')
                }
            })

            if (!client_plan.value) {
                client_plan.classList.add('invalid')
                isValid = false
            } else {
                client_plan.classList.remove('invalid')
            }

            return isValid && this.isValidEmail && this.isValidPhone
        },
    }
}
</script>
<style>
    input.invalid, select.invalid{
        border-color: red !important;
    }
</style>
